import { z } from 'zod';

export const LoginSchema = z.object({
  email: z.string().min(1, 'Adres e-mail jest wymagany').email('Niepoprawny format adresu e-mail'),
  password: z.string().min(1, 'Hasło jest wymagane'),
});

export const RegisterSchema = z
  .object({
    name: z.string().min(1, 'Imię lub pseudonim jest wymagane'),
    email: z.string().min(1, 'Adres e-mail jest wymagany').email('Niepoprawny format adresu e-mail'),
    password: z.string().min(6, 'Hasło musi mieć co najmniej 6 znaków'),
    confirmPassword: z.string().min(1, 'Powtórzenie hasła jest wymagane'),
    profession: z.string().optional().default('coach'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Hasła nie są identyczne',
    path: ['confirmPassword'],
  });

export const ForgotPasswordSchema = z.object({
  email: z.string().min(1, 'Adres e-mail jest wymagany').email('Niepoprawny format adresu e-mail'),
});

export type LoginFormData = z.infer<typeof LoginSchema>;
export type RegisterFormData = z.infer<typeof RegisterSchema>;
export type RegisterInput = z.input<typeof RegisterSchema>;
export type ForgotPasswordFormData = z.infer<typeof ForgotPasswordSchema>;
